import { render } from "./AnnouncementUnfulfilledPurchasesPage.vue?vue&type=template&id=13bca6ce"
import script from "./AnnouncementUnfulfilledPurchasesPage.vue?vue&type=script&lang=js"
export * from "./AnnouncementUnfulfilledPurchasesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__